/* eslint-disable */
import React, { useState, useEffect } from 'react';

export const useDebounce = (value: any, delay: number) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const handler = setTimeout(() => {
            if (value !== debouncedValue) {
                setDebouncedValue(value);
            }
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value]);
    return debouncedValue;
};
